/** Brand-anchored pastel tints for section headers (My Day / Inbox).
 * Replaces the rainbow palette with cohesive Avida brand variants. */

export const PASTEL = {
  // Brand sunflower — for "Next action due"
  yellow: { tint: "#FFF9C4", accent: "#F57F17", border: "#FFE082" },
  // Brand sky — for "Tasks assigned to me"
  sky:    { tint: "#E1F5FE", accent: "#0277BD", border: "#B3E5FC" },
  // Brand navy soft — for "Mentions"
  navy:   { tint: "#E8EAF6", accent: "#283593", border: "#C5CAE9" },
  // Brand royal — for "Overdue in stage"
  royal:  { tint: "#E3F2FD", accent: "#1565C0", border: "#90CAF9" },
  // Soft warm — for "Blocked"
  warm:   { tint: "#FFE5B4", accent: "#E65100", border: "#FFCC80" },
  // Calm green — for "Completed / Services Start"
  green:  { tint: "#E8F5E9", accent: "#2E7D32", border: "#A5D6A7" },

  // Aliases kept for backwards compatibility with existing pages
  blue:   { tint: "#E3F2FD", accent: "#1565C0", border: "#90CAF9" },
  orange: { tint: "#FFE5B4", accent: "#E65100", border: "#FFCC80" },
  violet: { tint: "#E8EAF6", accent: "#283593", border: "#C5CAE9" },
  pink:   { tint: "#FFE5B4", accent: "#E65100", border: "#FFCC80" },
};
